
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 4v2c1.883 0 2.746.422 3.313.969.566.547.898 1.375 1.25 2.375.351 1 .734 2.172 1.718 3.125.223.215.473.422.75.594A7.998 7.998 0 008 20c0 4.406 3.594 8 8 8 4.406 0 8-3.594 8-8 0-2.965-1.625-5.555-4.031-6.938.277-.171.527-.378.75-.593.984-.953 1.367-2.125 1.718-3.125.352-1 .684-1.828 1.25-2.375C24.255 6.422 25.117 6 27 6V4c-2.21 0-3.734.578-4.719 1.531-.984.953-1.367 2.125-1.718 3.125-.352 1-.684 1.828-1.25 2.375-.567.547-1.43.969-3.313.969-1.883 0-2.746-.422-3.313-.969-.566-.547-.898-1.375-1.25-2.375-.351-1-.734-2.172-1.718-3.125C8.734 4.578 7.21 4 5 4zm11 10c3.324 0 6 2.676 6 6s-2.676 6-6 6-6-2.676-6-6 2.676-6 6-6z"}})])
          )
        }
      }
    